import React, { useEffect } from 'react'
import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import CLOSE_ICON from '../../../../public/assets/mobile/close.svg'
import BaseButton from '../../../components/common/BaseButton'

const stopOverlayPropagation = (event: React.SyntheticEvent) => {
  event.stopPropagation()
  event.nativeEvent.stopImmediatePropagation?.()
}

const stopWheelPropagation = (
  event: React.WheelEvent,
  onInteraction?: (isOpen?: boolean) => void
) => {
  onInteraction?.()
  event.stopPropagation()
  event.nativeEvent?.stopImmediatePropagation?.()
}

export const NarrativeOcgMobileFullScreen = ({
  title,
  headerIcon,
  variant = 'reference',
  onClose,
  onInteraction,
  children,
}: {
  title: string
  headerIcon?: string
  variant?: 'reference' | 'error' | 'warning'
  onClose: () => void
  onInteraction?: (isOpen?: boolean) => void
  children: ReactNode
}) => {
  useEffect(() => {
    onInteraction?.(true)
    const interactionInterval = window.setInterval(() => {
      onInteraction?.()
    }, 500)

    return () => {
      window.clearInterval(interactionInterval)
      onInteraction?.(false)
    }
  }, [onInteraction])

  const screen = (
    <div
      className={`narrative-ocg-mobile-screen narrative-ocg-mobile-screen--${variant}`}
      onClick={stopOverlayPropagation}
      onMouseDown={stopOverlayPropagation}
      onTouchStart={stopOverlayPropagation}
      onWheelCapture={event => stopWheelPropagation(event, onInteraction)}
      role="dialog"
      aria-modal="true"
    >
      <div className="narrative-ocg-mobile-screen__header">
        <div className="narrative-ocg-mobile-screen__title">
          {headerIcon ? <img src={headerIcon} alt="" /> : null}
          <span>{title}</span>
        </div>
        <BaseButton
          className="narrative-ocg-mobile-screen__close !min-h-0 !rounded !bg-transparent !p-0 shadow-none"
          fillMode="flat"
          onClick={event => {
            onInteraction?.()
            event.preventDefault()
            event.stopPropagation()
            onClose()
          }}
          themeColor="base"
          type="button"
          aria-label="Close"
        >
          <img src={CLOSE_ICON} alt="" />
        </BaseButton>
      </div>
      <div
        className="narrative-ocg-mobile-screen__body"
        onMouseDown={stopOverlayPropagation}
        onTouchStart={stopOverlayPropagation}
        onWheelCapture={event => stopWheelPropagation(event, onInteraction)}
      >
        {children}
      </div>
    </div>
  )

  if (typeof document === 'undefined') return screen

  return createPortal(screen, document.body)
}
